import React from "react";

export default function Main(): React.JSX.Element {
  return <></>;
}
